import { Component, OnInit } from "@angular/core";
import { MDBModalRef } from "ng-uikit-pro-standard";
import { Subject } from "rxjs";

@Component({
  selector: "ll-confirm-city",
  templateUrl: "./confirm-city.component.html",
  styleUrls: ["./confirm-city.component.scss"]
})
export class ConfirmCityComponent implements OnInit {
  action = new Subject();
  active_venues: number;

  constructor(public modalRef: MDBModalRef) {}

  ngOnInit(): void {}

  yes() {
    this.action.next(true);
    this.modalRef.hide();
  }
  no() {
    this.action.next(false);
    this.modalRef.hide();
  }
}
